import { Component, OnInit } from '@angular/core';

import { first } from "rxjs/operators";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LigneFinancementProduit } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancementProduit';
import { LigneFinancementProduitService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement-produit.service';

@Component({
  selector: "app-editigne-financement-produit",
  templateUrl: "./editigne-financement-produit.component.html",
  styleUrls: ["./editigne-financement-produit.component.scss"]
})
export class EditLigneFinancementProduitComponent implements OnInit {
  ligneFinancement: LigneFinancementProduit;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementService: LigneFinancementProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {}

  createForm(ligneFinancement: LigneFinancementProduit) {
    this.form2 = this.fb.group({
      code: [ligneFinancement.code, Validators.compose([Validators.required])],
      libelle: [
        ligneFinancement.libelle,
        Validators.compose([Validators.required])
      ],
      montant: [
        ligneFinancement.montant,
        Validators.compose([Validators.required])
      ],
      codeLigneFinancementSecteur: [
        ligneFinancement.ligneFinancementSecteurId,
        Validators.compose([Validators.required])
      ]
    });
  }

  ngOnInit() {
    this.createForm(this.ligneFinancement);
  }

  save(): void {
    this.pressButton = true;
    const id = this.ligneFinancement.id;
    this.ligneFinancement = this.form2.value;
    this.ligneFinancement.id = id;

    this._ligneFinancementService
      .update(this.ligneFinancement)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close(this.ligneFinancement);
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
